import isEmpty from 'lodash/isEmpty';
import type { FC } from 'react';
import React, { memo, useMemo } from 'react';

import { Carousel } from '@sravni/react-design-system';

import Card from '@src/components/ProductList/components/Card';
import { getKey } from '@src/components/ProductList/utils/getKey';
import type { ListKeys } from '@src/constants/microcredits';
import { useSelectCreditsList } from '@src/reducers/microcredits';

import styles from './styles.module.scss';

interface IProps {
    listKey: ListKeys;
    title?: string;
}

const BestProducts: FC<IProps> = memo((props: IProps) => {
    const { listKey, title } = props;
    const bestProductList = useSelectCreditsList(listKey);

    const content = useMemo(
        () =>
            bestProductList?.items?.slice(0, 4).map((item, index) => {
                const key = getKey(item._id, index, listKey);

                return (
                    <Card
                        className={styles.card}
                        offer={{
                            ...item,
                            advertising: item.advertising && {
                                ...item.advertising,
                                buttonEventAction: 'Платный клик|ТОП4',
                            },
                        }}
                        key={key}
                        position={index}
                        withDisclaimer
                    />
                );
            }),
        [bestProductList, listKey],
    );

    if (isEmpty(bestProductList.items)) {
        return null;
    }

    return (
        <div className={styles.bestProductWrapper}>
            <div className={styles.carousel}>
                <Carousel title={title || 'Лучшие предложения дня'}>{content}</Carousel>
            </div>
        </div>
    );
});

export { BestProducts };
